import { gql } from '@apollo/client';

export const LOB_PRODUCT_LIST = gql`
  query lobProductList {
    lobProductList {
      lob_name
      lob_code
      products {
        product_name
        product_code
        product_types {
          code
          value
        }
        linkTo
      }
    }
  }
`;
